import React from 'react';
import { ICONS } from "../../constants/imageConstants";
import { ChevronRightIcon } from '../Icons/svgIcons';

const SettingsItem = ({
  label,
  description,
  value,
  onClick,
  showChevron = true,
  rightContent,
  icon,
  iconBg, 
  className = '',
  destructive = false
}) => {
  return (
    <div
      className={`flex items-center justify-between px-4 py-4 min-h-[60px] transition-colors active:bg-gray-50 ${onClick ? 'active:scale-[0.99] cursor-pointer hover:bg-gray-50' : ''} ${className}`}
      onClick={onClick}
    >
      <div className="flex items-center gap-3 flex-1 min-w-0">
        {icon && (
          <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${destructive ? 'bg-red-50 text-red-600' : (iconBg || 'bg-gray-100 text-gray-600')}`}>
            {icon}
          </div>
        )}
        <div className="flex-1 min-w-0">
          <div className={`text-sm font-semibold ${destructive ? 'text-red-600' : 'text-gray-900'}`}>
            {label}
          </div>
          {description && (
            <div className="text-xs text-gray-500 mt-0.5 line-clamp-1">
              {description}
            </div>
          )}
        </div>
      </div>

      <div className="flex items-center gap-3 flex-shrink-0">
        {value && (
          <span className="text-sm font-bold text-gray-900">{value}</span>
        )}
        {rightContent}
        {showChevron && onClick && (
         <ChevronRightIcon className="w-4 h-4 text-gray-400" />
        )}
      </div>
    </div>
  );
};

export default SettingsItem;